import React, { useState, memo } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TickerMarquee } from './components/TickerMarquee';
import { About } from './components/About';
import { StrategySection } from './components/StrategySection';
import { InvestorSection } from './components/InvestorSection';
import { LoginModal } from './components/LoginModal';
import { Footer } from './components/Footer';
import { ContentModal } from './components/ContentModal';
import { RequestAllocationModal } from './components/RequestAllocationModal';
export type ModalType = 'none' | 'login' | 'terms' | 'privacy' | 'adv' | 'allocation';
export function App() {
  const [activeModal, setActiveModal] = useState<ModalType>('none');
  const closeModal = () => setActiveModal('none');
  return <div className="min-h-screen bg-base-950 text-slate-300 font-sans selection:bg-gold-400/30 selection:text-white" data-id="element-0">
      <Navbar onLoginClick={() => setActiveModal('login')} data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TickerMarquee data-id="element-4" />
        <About data-id="element-5" />
        <StrategySection data-id="element-6" />
        <InvestorSection onLoginClick={() => setActiveModal('login')} onRequestAllocation={() => setActiveModal('allocation')} data-id="element-7" />
      </main>

      <Footer onOpenModal={type => setActiveModal(type)} data-id="element-8" />

      {/* Modals */}
      <LoginModal isOpen={activeModal === 'login'} onClose={closeModal} data-id="element-9" />

      <RequestAllocationModal isOpen={activeModal === 'allocation'} onClose={closeModal} data-id="element-10" />

      <ContentModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Terms of Use" content={<>
            <p data-id="element-12">Last Updated: October 2023</p>
            <p data-id="element-13">
              Please read these Terms of Use ("Terms") carefully before using
              the Delta Street website. By accessing or using the website, you
              agree to be bound by these Terms. If you disagree with any part of
              the terms, then you may not access the website.
            </p>
            <h3 data-id="element-14">1. Informational Purposes Only</h3>
            <p data-id="element-15">
              The information contained on this website is for informational
              purposes only and does not constitute an offer to sell or a
              solicitation of an offer to buy any interest in any investment
              vehicle managed by 22Fund LLC (d/b/a Delta Street). Any such offer
              or solicitation will be made only by means of a confidential
              private placement memorandum and only in jurisdictions where
              permitted by law.
            </p>
            <h3 data-id="element-16">2. No Investment Advice</h3>
            <p data-id="element-17">
              Nothing contained on this website constitutes investment, legal,
              tax or other advice nor is to be relied on in making an investment
              or other decision. You should obtain relevant and specific
              professional advice before making any investment decision.
            </p>
            <h3 data-id="element-18">3. Past Performance</h3>
            <p data-id="element-19">
              Past performance is not indicative of future results. Investment
              in a hedge fund is speculative and involves a high degree of risk.
              The strategies described herein are subject to change without
              notice.
            </p>
          </>} data-id="element-11" />

      <ContentModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Privacy Policy" content={<>
            <p data-id="element-21">Last Updated: October 2023</p>
            <p data-id="element-22">
              Delta Street ("we", "us", or "our") is committed to protecting
              your privacy. This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you visit our
              website.
            </p>
            <h3 data-id="element-23">1. Information We Collect</h3>
            <p data-id="element-24">
              We may collect personal information that you voluntarily provide
              to us when you express an interest in obtaining information about
              us or our products and services. The personal information that we
              collect depends on the context of your interactions with us and
              the website, the choices you make, and the products and features
              you use.
            </p>
            <h3 data-id="element-25">2. How We Use Your Information</h3>
            <p data-id="element-26">
              We use personal information collected via our website for a
              variety of business purposes described below. We process your
              personal information for these purposes in reliance on our
              legitimate business interests, in order to enter into or perform a
              contract with you, with your consent, and/or for compliance with
              our legal obligations.
            </p>
            <h3 data-id="element-27">3. Information Security</h3>
            <p data-id="element-28">
              We have implemented appropriate technical and organizational
              security measures designed to protect the security of any personal
              information we process. However, despite our safeguards and
              efforts to secure your information, no electronic transmission
              over the Internet or information storage technology can be
              guaranteed to be 100% secure.
            </p>
          </>} data-id="element-20" />

      <ContentModal isOpen={activeModal === 'adv'} onClose={closeModal} title="Form ADV Disclosure" content={<>
            <p data-id="element-30">
              Delta Street is a DBA of 22Fund LLC, an investment adviser
              registered with the Securities and Exchange Commission (SEC).
              Registration with the SEC does not imply a certain level of skill
              or training.
            </p>
            <h3 data-id="element-31">Form ADV Part 2A (Brochure)</h3>
            <p data-id="element-32">
              Our Form ADV Part 2A provides information about our qualifications
              and business practices. If you have any questions about the
              contents of this brochure, please contact us at
              investors@deltastreet.co. The information in this brochure has not
              been approved or verified by the United States Securities and
              Exchange Commission or by any state securities authority.
            </p>
            <p data-id="element-33">
              Additional information about 22Fund LLC also is available on the
              SEC's website at www.adviserinfo.sec.gov.
            </p>
            <div className="mt-8 p-4 bg-base-950 border border-slate-800 rounded-sm" data-id="element-34">
              <p className="font-mono text-xs text-gold-400 mb-2" data-id="element-35">
                DOWNLOADABLE DOCUMENTS
              </p>
              <ul className="space-y-2" data-id="element-36">
                <li data-id="element-37">
                  <a href="#" className="text-slate-300 hover:text-white underline underline-offset-4" data-id="element-38">
                    Form ADV Part 2A (PDF)
                  </a>
                </li>
                <li data-id="element-39">
                  <a href="#" className="text-slate-300 hover:text-white underline underline-offset-4" data-id="element-40">
                    Form CRS (PDF)
                  </a>
                </li>
              </ul>
            </div>
          </>} data-id="element-29" />
    </div>;
}